<template>
  <vb-tabs class="tabbed-info">
    <b-tab
      v-for="(item, index) in tabs"
      :key="`${_uid}:${index}:${id}`"
      :title="item.title"
      class="tabbed-info__tab"
    >
      <span v-html="item.body"></span>
    </b-tab>
  </vb-tabs>
</template>

<script>
  export default {
    name: 'tabbed-info',
    props: {
      id: {
        type: String,
        default: '',
      },
      items: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      // i titoli arrivano con casing incoerente fra brand (es. "POSIZIONE E STRUTTURA")
      tabs() {
        return this.items.map((item) => {
          const { title = '' } = item;
          return {
            ...item,
            title: title.charAt(0).toUpperCase() + title.slice(1).toLowerCase(),
          };
        });
      },
    },
  };
</script>
